export default __webpack_public_path__ + "static/media/Coach.7d395a0d.jpg";